import React, { useState } from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import Colors from "../constants/Colors";
import DefaultTextBold from "./text/DefaultTextBold";

const SelectionItem = (props) => {
  const items = props.items;
  return (
    <View style={styles.row}>
      {items.map((item) => {
        return (
          <TouchableOpacity
            style={[styles.button, props.buttonStyle]}
            onPress={() => {
              props.onPressHandler(props.config, item);
            }}
            key={item}
          >
            <DefaultTextBold
              style={[
                styles.textContainer,
                {
                  backgroundColor:
                    item === props.selectedItem ? "white" : Colors.background,
                  color: item === props.selectedItem ? "black" : Colors.primary,
                },
              ]}
            >
              {item}
            </DefaultTextBold>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
  },
  button: {
    //   marginBottom: 10
  },
  textContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-evenly",
    borderWidth: 1,
    borderColor: "white",
    padding: 8,
  },
});

export default SelectionItem;
